import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import {
  type CreateTenantDivisionMutationError,
  getListTenantDivisionsQueryKey,
  useCreateTenantDivision,
} from '@/entities/tenants-divisions/api/generated/api';
import { toast } from '@/shared/ui';

export const useOrganizationsCreateMutation = ({ onSuccess }: { onSuccess: () => void }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useCreateTenantDivision({
    request: { suppressToast: true },
    mutation: {
      onSuccess: () => {
        toast.success(
          t('common.messages.create-success', {
            name: t('master-management.menu.organizations'),
          }),
        );
        queryClient.invalidateQueries({
          queryKey: getListTenantDivisionsQueryKey(),
        });
        onSuccess();
      },
      onError: (error: CreateTenantDivisionMutationError) => {
        if (error.response?.data.error_code === 'VALIDATION_ERROR') {
          toast.error(t('master-management.organizations.create.error.duplicate-code'));
          return;
        }
        toast.error(
          t('common.messages.create-failed', {
            name: t('master-management.menu.organizations'),
          }),
        );
      },
    },
  });
};
